/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { orderConfirmationAccountSignUpMessageStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationAccountSignUpMessage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

orderConfirmationAccountSignUpMessageStyles.container = {
    css: css`
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        flex-wrap: wrap;
        margin-bottom: 20px;
        padding: 10px;
        width: 100%;
    `,
};

orderConfirmationAccountSignUpMessageStyles.createAccountText = {
    css: css`
        margin-bottom: 16px;
        display: block;
    `,
};

orderConfirmationAccountSignUpMessageStyles.createAccountButton = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};
